import React, { useEffect, useState } from "react";
import SignatureProfilesView from "../../views/signature-profiles/signature-profiles.view";
import {
  SignatureProfileService,
  LocalStorageService,
} from "../../../services";
import { SimpleLoading } from "../../pures";

function SignatureProfilesContainer(props) {
  const url = process.env.REACT_APP_MIFIRMA_API;
  const [signatureProfilesService, setSignatureProfilesService] =
    useState(null);
  const [token, setToken] = useState("");
  const [load, setLoad] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    const loadToken = async () => {
      const localStorageService = new LocalStorageService();
      let getToken = localStorageService.getLocalStorageItem("token").idToken;
      setToken(getToken);
    };
    loadToken();
    setSignatureProfilesService(new SignatureProfileService(url));
    setLoad(true);
  }, []);

  const getProfiles = async () => {
    setIsLoading(true);
    await signatureProfilesService
      .getSignatureProfiles(token, 2)
      .then((res) => {
        setProfiles(res.data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (load) {
      getProfiles();
    }
  }, [load]);
  return <div className="standard-wrapper">
    {props.children({ load, isLoading, profiles, getProfiles, token })}
  </div>
}

export default function SignatureProfilesAction() {
  return (
    <SignatureProfilesContainer>
      {({ load, isLoading, profiles, getProfiles, token, }) =>
        !load || isLoading ? (
          <div>
            <SimpleLoading />
          </div>
        ) : (
          <SignatureProfilesView
            profiles={profiles}
            token={token}
            getProfiles={getProfiles}
          />
        )
      }
    </SignatureProfilesContainer>
  );
}
